// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"97e514f5","17":"076b2a1a","36":"d533c0b0","89":"6b0a9259","140":"3922e468","191":"1cb4155c","202":"1550a971","209":"bb7f7964","220":"8d025937","284":"cb05331a","302":"a48eb972","348":"aef81c84","854":"d409f17c","873":"1daef9d0","994":"19996539"}[chunkId] + ".chunk.js";
};